
/**
 * params required
 * origin: origen de donde se invoca el component
 * action: acción a realizar
 * params: {
 *  idperson: 
 *  idpayroll:
 * }
 */

import { defineComponent, ref, provide, reactive, computed, onMounted, watchEffect } from "vue"
import type { FormInstance, FormRules } from "element-plus";
import { ElNotification } from 'element-plus'
import { useStore } from "vuex";
//components
import ModalAlergyPerson from "@/views/allergies/Modals/AlergyPerson.vue"

//services
import PayrollService from "@/core/services/PayrollService"
import { errManager } from "@/core/config/Tools";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import personService from "@/core/services/PersonService";

export default defineComponent({
    name: "swPersona",
    props: {
        action: {
            type: Number,
            required: true,
            default: 0,
        },
        origin: {
            type: String,
            required: true,
            default: 'default'
        },
        params: {
            type: Object,
            required: true,
            default: { idperson: null, idpayroll: null }
        }
    },
    components: { ModalAlergyPerson },
    emits: ["onResponse"],
    setup(props, { emit }) {
        const loader = ref(false)
        const loaderAllergy = ref(false)
        const store = useStore();
        const maxlength = ref(8)
        const minlength = ref(3)
        const inputRef = ref<HTMLInputElement | null>(null);
        const pattern = ref<any>(/^[0-9]+$/)
        const listAllergy = ref<any>([])
        const swFormRef = ref<FormInstance>()
        const swForm = reactive(<any>{
            doctype: '1',
            docnumber: null,
            stature: null,
            peso: null,
            marital_status: null,
            blood_type: null,
            ocupation: null,
            listAllergy: listAllergy.value
        })
        const rules = reactive<FormRules>({})
        const actionAllergy = ref(1)
        const dialogAlergy = ref(false)

        //provides
        provide("dialogAlergy", dialogAlergy)

        const getDocuments: any = computed<any>(() => {
            return store.getters.currentUser.type_documents;
        })

        const getGender: any = computed<any>(() => {
            return store.getters.currentUser.gender;
        })

        const maritalStatus: any = computed<any>(() => {
            return store.getters.currentUser.marital_status;
        })

        const bloodType: any = computed<any>(() => {
            return store.getters.currentUser.blood_type;
        })

        const getUbigeo: any = computed<any>(() => {
            return store.getters.currentUser.ubigeo;
        })

        const getCountry: any = computed<any>(() => {
            return store.getters.currentUser.country;
        })

        const changeDocType = () => {
            swForm.docnumber = "";
            if (swForm.doctype == "1") {
                maxlength.value = minlength.value = 8
                //pattern.value = /^[0-9]+$/
            } else {
                maxlength.value = 13
                minlength.value = 3
                pattern.value = /^[a-zA-Z0-9]+$/
            }
            inputRef.value?.focus()
        }

        watchEffect(async () => {
            await getUbigeo;
        })

        const submitForm = async (formEl: FormInstance | undefined) => {
            if (!formEl) return;
            await formEl.validate((valid, fields) => {
                if (valid) {
                    if (props.action == 1)
                        onSave();
                    else
                        onUpdate();
                }
            });
        };

        const onSave = async () => {
            loader.value = true
            await PayrollService.options('save', swForm)
                .then((res) => {
                    loader.value = false
                    Swal.fire({
                        icon: res.data.status,
                        title: res.data.title,
                        html: res.data.message
                    })
                    emit("onResponse", res.data)
                }).catch(({ response }) => {
                    loader.value = false
                    errManager(response)
                })
        }

        const onUpdate = async () => {
            loader.value = true
            await PayrollService.update(props.params.idpayroll, swForm)
                .then((res) => {
                    loader.value = false
                    Swal.fire({
                        icon: res.data.status,
                        title: res.data.title,
                        html: res.data.message
                    })
                }).catch(({ response }) => {
                    loader.value = false
                    errManager(response)
                })
        }

        const oPenDialogAlergy = () => {
            actionAllergy.value = 1
            dialogAlergy.value = true
        }

        onMounted(() => {
            if (props.action == 1) //search data person
                getPerson()
            else //search planilla
                getPayrool()

            //console.log(swForm.idperson)
            //let _idperson = ("idperson" in props.params) ? props.params.idperson : null
            //if(_idperson) getListAllergy()
        })

        const getPerson = async () => {
            if ("person" in props.params) {
                Object.assign(swForm, props.params.person)
            }
        }

        const getPayrool = async () => {
            loader.value = true
            let values = ("payroll" in props.params) ? props.params.payroll : props.params

            await PayrollService.get(values.idpayroll)
                .then((res) => {
                    Object.assign(swForm, res.data.payroll)
                    loader.value = false
                    getListAllergy()
                }).catch(({ response }) => {
                    loader.value = false
                    errManager(response)
                })
        }

        const onResponseAllergy = (values: any) => {
            if (values.status) {
                getListAllergy()
            } else {
                let itemAllergy = {
                    idperson: values.params.idperson,
                    idallergy: values.params.idallergy?.id,
                    allergyName: values.params.idallergy?.name,
                    idseverity: values.params.idseverity?.id,
                    severityName: values.params.idseverity.name,
                    reactions: values.params.reactions,
                    mstatus: values.params.mstatus
                }
                listAllergy.value.push(itemAllergy)
            }
        }

        const getListAllergy = async () => {
            loaderAllergy.value = true
            await personService.getOptions(swForm.idperson, 'allergys')
                .then((res) => {
                    listAllergy.value = res.data
                    loaderAllergy.value = false
                }).catch(({ response }) => {
                    loaderAllergy.value = false
                    errManager(response)
                })
        }

        const deleteAllergy = async (row: any) => {
            loaderAllergy.value = true
            await personService.deleteOptions('allergy', row.id)
                .then((res) => {
                    loaderAllergy.value = false
                    if (res.data.status == 'success') getListAllergy()
                    ElNotification({
                        title: res.data.title,
                        message: res.data.message,
                        type: res.data.status,
                    })
                }).catch(({ response }) => {
                    loaderAllergy.value = false
                    errManager(response)
                })
        }

        return {
            loader,
            loaderAllergy,
            swFormRef,
            swForm,
            rules,
            maxlength,
            minlength,
            inputRef,
            pattern,
            actionAllergy,
            listAllergy,
            dialogAlergy,

            //methods
            changeDocType,
            getDocuments,
            getGender,
            getUbigeo,
            maritalStatus,
            bloodType,
            getCountry,
            submitForm,
            onSave,
            onUpdate,
            oPenDialogAlergy,
            onResponseAllergy,
            getListAllergy,
            deleteAllergy
        }

    },
})
